// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"139":"95cf4e51","787":"c552ac23","840":"a5ea58c3"}[chunkId] + ".chunk.js";
};